import { FEATURE_SHOW_MIAW_CHAT } from '../../consts/env'
import { getPageStatus } from './customerServiceIntegration/getPageStatus'
import { BotType, MiawConfig } from './types'

const {
  REACT_APP_MIAW_SITEURL,
  REACT_APP_MIAW_ORGID,
  REACT_APP_MIAW_ESWCONFIGDEVNAME,
  REACT_APP_MIAW_SNIPPETCONFIGURL,
  REACT_APP_AGENT_FORCE_SITEURL,
  REACT_APP_AGENT_FORCE_ESWCONFIGDEVNAME,
} = process.env

const MIAW_CONFIG: MiawConfig = {
  siteURL: REACT_APP_MIAW_SITEURL!,
  orgID: REACT_APP_MIAW_ORGID!,
  eswConfigDevName: REACT_APP_MIAW_ESWCONFIGDEVNAME!,
  snippetConfigURL: REACT_APP_MIAW_SNIPPETCONFIGURL!,
  hideChatButtonOnLoad: FEATURE_SHOW_MIAW_CHAT ? getPageStatus().isInCustomerServicePage : true,
}

const AGENT_FORCE_CONFIG: MiawConfig = {
  siteURL: REACT_APP_AGENT_FORCE_SITEURL!,
  orgID: REACT_APP_MIAW_ORGID!,
  eswConfigDevName: REACT_APP_AGENT_FORCE_ESWCONFIGDEVNAME!,
  snippetConfigURL: REACT_APP_MIAW_SNIPPETCONFIGURL!,
  hideChatButtonOnLoad: true,
}

const getConfig = (botType: BotType): MiawConfig => (botType === BotType.AGENT_FORCE ? AGENT_FORCE_CONFIG : MIAW_CONFIG)

export default getConfig
